export default __webpack_public_path__ + "static/media/020310202145100.76efca5e.png";